import { useState, useEffect } from 'react';
import { Aurora, GrainOverlay } from '../components/Background';
import { CustomCursor } from '../components/CustomCursor';
import { Nav } from '../components/Nav';
import { Hero } from '../sections/Hero';
import { About } from '../sections/About';
import { Skills } from '../sections/Skills';
import { Projects } from '../sections/Projects';
import { CTA } from '../sections/CTA';
import { Footer } from '../sections/Footer';

const SECTIONS = ['hero', 'about', 'skills', 'projects', 'footer'];

export default function Home() {
  const [activeSection, setActiveSection] = useState('hero');
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? (scrollY / docHeight) * 100 : 0);

      const pos = scrollY + 220;
      for (const id of SECTIONS) {
        const el = document.getElementById(id);
        if (el && pos >= el.offsetTop && pos < el.offsetTop + el.offsetHeight) {
          setActiveSection(id);
          break;
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="app">
      <CustomCursor />
      <Aurora />
      <GrainOverlay />
      <div className="scroll-progress" style={{ width: `${progress}%` }} />

      <Nav activeSection={activeSection} onNavigate={scrollToSection} />
      <main>
        <Hero onNavigate={scrollToSection} />
        <About />
        <Skills />
        <Projects />
        <CTA />
      </main>
      <Footer onNavigate={scrollToSection} />
    </div>
  );
}
